import type { ContentItem } from './types'

/** Top-12 long-form handoff pages (08 Oct 2026). Lyrics from supplied PDFs only. */
export const HANDOFF_CONTENTS: ContentItem[] = [
  {
    id: 'narayani-stuti',
    slug: 'narayani-stuti-tamil-lyrics-meaning',
    publicPath: '/narayani-stuti-tamil-lyrics-meaning/',
    type: 'traditional-stuti',
    titleTa: 'நாராயணி ஸ்துதி – தமிழ் வரிகள், பொருள் & PDF',
    cardTitleTa: 'நாராயணி ஸ்துதி',
    titleEn: 'Narayani Stuti Tamil',
    deity: 'amman',
    eyebrowTa: 'நவராத்திரி சிறப்பு • தேவி ஸ்துதி',
    featured: true,
    seasonalTags: ['navratri-2026'],
    shortIntroTa:
      'நாராயணி ஸ்துதி தேவி மஹாத்மியத்தின் 11-ஆம் அதிகாரத்தில் இடம்பெறும் தேவியைப் போற்றும் ஸ்துதி. “சர்வ மங்கள மாங்கல்யே…” எனப் பரவலாக அறியப்படும் பாடலும் இந்த ஸ்துதியின் ஒரு பகுதியாகும். இந்தப் பக்கத்தில் தெய்வீக ஓசை பாடலைக் கேட்கலாம். அங்கீகரிக்கப்பட்ட தமிழ் வரிகள் மற்றும் PDF தயாரானதும் இங்கே சேர்க்கப்படும்.',
    occasionTa: 'நவராத்திரி, தேவி வழிபாடு, வெள்ளிக்கிழமை',
    originTa:
      'நாராயணி ஸ்துதி தேவி மஹாத்மியம் / துர்கா சப்தசதி (Durga Saptashati) 11-ஆம் அதிகாரத்துடன் தொடர்புடைய பாரம்பரிய தேவி ஸ்துதி. “சர்வ மங்கள மாங்கல்யே” வரி இந்த ஸ்துதியின் நன்கு அறியப்பட்ட பகுதி. பலன் குறித்த விளக்கங்கள் பாரம்பரிய பக்தி நம்பிக்கையாக மட்டுமே புரிந்துகொள்ளப்பட வேண்டும்.',
    youtubeVideoId: 'QGilkQAGZ4M',
    youtubePublishedAt: '2026-10-12',
    keywords: [
      'நாராயணி ஸ்துதி',
      'narayani stuti tamil',
      'sarva mangala mangalye',
      'சர்வ மங்கள மாங்கல்யே',
      'navratri',
      'அம்மன்',
    ],
    seoTitle: 'நாராயணி ஸ்துதி தமிழ் வரிகள் & பொருள் | Narayani Stuti Tamil',
    seoTitleExact: true,
    seoDescription:
      'நாராயணி ஸ்துதி தமிழ் வரிகள், எளிய பொருள், Sarva Mangala Mangalye பகுதி, Deiveega Oosai வீடியோ மற்றும் இலவச PDF – நவராத்திரி சிறப்பு.',
    disclaimerTa:
      'இந்த ஸ்துதியின் பலன் பாரம்பரிய பக்தி நம்பிக்கையாக மட்டுமே சொல்லப்படுகிறது. செல்வம், நோய் நீக்கம் அல்லது வேறு எந்த முடிவும் உத்தரவாதம் அளிக்கப்படுவதில்லை.',
    lyricsPending: true,
    relatedIds: ['mahalakshmi-ashtakam', 'kanakadhara-stotram', 'abirami-16-blessings', 'aigiri-nandini'],
    verses: [],
  },
  {
    id: "ganesha-pancharatnam",
    slug: "ganesha-pancharatnam-tamil-lyrics-meaning",
    type: "traditional-stuti",
    titleTa: "கணேச பஞ்சரத்னம் - தமிழ் வரிகள், எளிய பொருள் & வீடியோ",
    titleEn: "Ganesha Pancharatnam",
    deity: "vinayagar",
    shortIntroTa: "ஆதி சங்கரருக்கு பாரம்பரியமாகச் சேர்த்துக் கூறப்படும் கணேச பஞ்சரத்னம், “முதாகராத்த மோதகம்” என்று தொடங்கும் புகழ்பெற்ற விநாயகர் ஸ்தோத்திரம். விநாயகரின் அருள், ஞானம், தடைகளை எதிர்கொள்ளும் மனவலிமை மற்றும் மங்களமான தொடக்கம் ஆகியவற்றை வேண்டி பக்தர்கள் இதைப் பாராயணம் செய்கிறார்கள்.",
    occasionTa: "காலை பூஜை • விநாயகர் வழிபாடு • சதுர்த்தி • புதிய முயற்சிகளுக்கு முன் மனதை ஒருமுகப்படுத்தும் நேரம்",
    originTa: "பாரம்பரியமாக ஆதி சங்கரருக்கு உரியதாகப் போற்றப்படுகிறது. PDF உரை Stotra Nidhi சரிபார்ப்புடன் வழங்கப்பட்டுள்ளது.",
    youtubeVideoId: "N46hgwg5NhQ",
    pdfUrl: "/downloads/01_Ganesha_Pancharatnam_Tamil.pdf",
    keywords: ["கணேச பஞ்சரத்னம்", "ganesha pancharatnam", "mudakaratha modakam", "விநாயகர்", "vinayagar"],
    seoTitle: "கணேச பஞ்சரத்னம் தமிழ் வரிகள் & பொருள் | Mudakaratha Modakam",
    seoDescription: "கணேச பஞ்சரத்னம் (Mudakaratha Modakam) தமிழ் எழுத்து, எளிய பொருள், தெய்வீக ஓசை வீடியோ மற்றும் mobile-friendly PDF உடன் படித்து கேளுங்கள்.",
    relatedIds: ["runa-vimochana-ganapati", "vinayagar-potri-108", "vinayagar-mantras"],
    verses: [
      {
        tamil: `முதா³ கராத்தமோத³கம் ஸதா³ விமுக்திஸாத⁴கம்
கலாத⁴ராவதம்ஸகம் விளாஸிலோகரக்ஷகம் ।
அநாயகைகநாயகம் விநாஶிதேப⁴தை³த்யகம்
நதாஶுபா⁴ஶுநாஶகம் நமாமி தம் விநாயகம் ॥`,
        meaningTa: `மோதகத்தை விரும்பும், பக்தரை உயர்ந்த நிலைக்கு வழிநடத்தும், உலகைக் காக்கும் விநாயகரை வணங்குகிறோம்.`,
      },
      {
        tamil: `நதேதராதிபீ⁴கரம் நவோதி³தார்கபா⁴ஸ்வரம்
நமத்ஸுராரிநிர்ஜரம் நதாதி⁴காபது³த்³த⁴ரம் ।
ஸுரேஶ்வரம் நிதீ⁴ஶ்வரம் க³ஜேஶ்வரம் க³ணேஶ்வரம்
மஹேஶ்வரம் தமாஶ்ரயே பராத்பரம் நிரந்தரம் ॥`,
        meaningTa: `பக்தருக்கு ஆதரவாக இருந்து இடர்களிலிருந்து காக்கும், தேவர்களாலும் போற்றப்படும் கணேசனை சரணடைகிறோம்.`,
      },
      {
        tamil: `ஸமஸ்தலோகஶங்கரம் நிரஸ்ததை³த்யகுஞ்ஜரம்
த³ரேதரோத³ரம் வரம் வரேப⁴வக்த்ரமக்ஷரம் ।
க்ருபாகரம் க்ஷமாகரம் முதா³கரம் யஶஸ்கரம்
மநஸ்கரம் நமஸ்க்ருதாம் நமஸ்கரோமி பா⁴ஸ்வரம் ॥`,
        meaningTa: `அனைவருக்கும் மங்களம் தரும், கருணையும் பொறுமையும் ஆனந்தமும் புகழும் வழங்கும் விநாயகரை வணங்குகிறோம்.`,
      },
      {
        tamil: `அகிஞ்சநார்திமார்ஜநம் சிரந்தநோக்திபா⁴ஜநம்
புராரிபூர்வநந்த³நம் ஸுராரிக³ர்வசர்வணம் ।
ப்ரபஞ்சநாஶபீ⁴ஷணம் த⁴நஞ்ஜயாதி³பூ⁴ஷணம்
கபோலதா³நவாரணம் ப⁴ஜே புராணவாரணம் ॥`,
        meaningTa: `துன்பமுற்றவரின் துயரை துடைத்து அகந்தையை அடக்கும், சிவபெருமானின் மகனான கணேசனை துதிக்கிறோம்.`,
      },
      {
        tamil: `நிதாந்தகாந்தத³ந்தகாந்திமந்தகாந்தகாத்மஜம்
அசிந்த்யரூபமந்தஹீநமந்தராயக்ருந்தநம் ।
ஹ்ருத³ந்தரே நிரந்தரம் வஸந்தமேவ யோகி³நாம்
தமேகத³ந்தமேவ தம் விசிந்தயாமி ஸந்ததம் ॥`,
        meaningTa: `அளவிட முடியாத திருவுருவமுடைய, இடர்களை நீக்கி யோகிகளின் உள்ளத்தில் நிலைபெறும் ஏகதந்தனை எப்போதும் நினைக்கிறோம்.`,
      },
      {
        tamil: `மஹாக³ணேஶபஞ்சரத்நமாத³ரேண யோ(அ)ந்வஹம்
ப்ரஜல்பதி ப்ரபா⁴தகே ஹ்ருதி³ ஸ்மரந்க³ணேஶ்வரம் ।
அரோக³தாமதோ³ஷதாம் ஸுஸாஹிதீம் ஸுபுத்ரதாம்
ஸமாஹிதாயுரஷ்டபூ⁴திமப்⁴யுபைதி ஸோ(அ)சிராத் ॥`,
        meaningTa: `இது பலஸ்ருதி. காலை கணேசனை நினைத்து இந்தப் பாடல்களைப் பாராயணம் செய்வதின் ஆன்மீக பலனை பாரம்பரியம் இவ்வாறு போற்றுகிறது.`,
      },
    ],
  },
  {
    id: "vaidyanatha-ashtakam",
    slug: "vaidyanatha-ashtakam-tamil-lyrics-meaning",
    type: "traditional-stuti",
    titleTa: "ஸ்ரீ வைத்தியநாத அஷ்டகம் - தமிழ் வரிகள், பொருள் & வீடியோ",
    titleEn: "Sri Vaidyanatha Ashtakam",
    deity: "shiva",
    shortIntroTa: "சிவபெருமான் வைத்தியநாதர் எனும் திருவடிவில் தெய்வீக மருத்துவராகப் போற்றப்படுகிறார். வைத்தியநாத அஷ்டகம், அவருடைய கருணையும் நலனுக்கான அருளையும் பாடும் எட்டு பாடல்களைக் கொண்ட ஸ்தோத்திரம். உடல் நலம், மன உறுதி மற்றும் குடும்ப நலனை வேண்டி பக்தியுடன் பாராயணம் செய்யப்படும் இந்த ஸ்தோத்திரத்தை மருத்துவ சிகிச்சைக்கான மாற்றாக அல்லாமல் ஆன்மீகப் பிரார்த்தனையாகவே வழங்க வேண்டும்.",
    occasionTa: "காலை அல்லது மாலை • சிவ வழிபாடு • உடல் நலம் மற்றும் மன உறுதி வேண்டிய ஆன்மீகப் பிரார்த்தனை நேரம்",
    originTa: "சிவபெருமானை வைத்தியநாதர் எனப் போற்றும் பாரம்பரிய அஷ்டகம்.",
    youtubeVideoId: "5aAqvmmouAc",
    pdfUrl: "/downloads/02_Vaidyanatha_Ashtakam_Tamil.pdf",
    keywords: ["வைத்தியநாத அஷ்டகம்", "vaidyanatha ashtakam", "shiva", "சிவன்", "வைத்தியநாதர்"],
    seoTitle: "வைத்தியநாத அஷ்டகம் தமிழ் வரிகள் & பொருள் | Shiva Stotram",
    seoDescription: "ஸ்ரீ வைத்தியநாத அஷ்டகம் தமிழ் எழுத்து, எளிய பொருள், முழு தெய்வீக ஓசை வீடியோ மற்றும் mobile PDF. நல்ல உடல் நலம் வேண்டிய ஆன்மீகப் பிரார்த்தனை.",
    disclaimerTa: "இந்த ஆன்மீகப் பதிவு மருத்துவ ஆலோசனை அல்லது சிகிச்சைக்கு மாற்றாக அல்ல. உடல்நலப் பிரச்சினைகளுக்கு தகுந்த மருத்துவரை அணுகவும்.",
    relatedIds: ["lingashtakam"],
    verses: [
      {
        tamil: `ஶ்ரீராமஸௌமித்ரிஜடாயுவேத³
ஷடா³நநாதி³த்ய குஜார்சிதாய ।
ஶ்ரீநீலகண்டா²ய த³யாமயாய
ஶ்ரீவைத்³யநாதா²ய நம꞉ ஶிவாய ॥`,
        meaningTa: `ராமர், லட்சுமணர், ஜடாயு, முருகன், சூரியன், செவ்வாய் உள்ளிட்டோரால் வணங்கப்படும் கருணைமிகு நீலகண்ட வைத்தியநாதரை வணங்குகிறோம்.`,
      },
      {
        tamil: `க³ங்கா³ப்ரவாஹேந்து³ ஜடாத⁴ராய
த்ரிலோசநாய ஸ்மர காலஹந்த்ரே ।
ஸமஸ்த தே³வைரபி⁴பூஜிதாய
ஶ்ரீவைத்³யநாதா²ய நம꞉ ஶிவாய ॥`,
        meaningTa: `கங்கை மற்றும் சந்திரனை ஜடையில் தாங்கும், மூன்று கண்களுடைய, தேவர்களால் வழிபடப்படும் சிவனை வணங்குகிறோம்.`,
      },
      {
        tamil: `ப⁴க்தப்ரியாய த்ரிபுராந்தகாய
பிநாகிநே து³ஷ்டஹராய நித்யம் ।
ப்ரத்யக்ஷலீலாய மநுஷ்யலோகே
ஶ்ரீவைத்³யநாதா²ய நம꞉ ஶிவாய ॥`,
        meaningTa: `பக்தர்களுக்கு அன்பான, திரிபுரங்களை அழித்த, தீமையை அகற்றும் வைத்தியநாதரை துதிக்கிறோம்.`,
      },
      {
        tamil: `ப்ரபூ⁴தவாதாதி³ ஸமஸ்தரோக³-
-ப்ரணாஶகர்த்ரே முநிவந்தி³தாய ।
ப்ரபா⁴கரேந்த்³வக்³நிவிளோசநாய
ஶ்ரீவைத்³யநாதா²ய நம꞉ ஶிவாய ॥`,
        meaningTa: `நோய்துன்பங்களிலிருந்து காக்கும் அருளை வேண்டி, முனிவர்களால் வணங்கப்படும் சூரிய-சந்திர-அக்னி கண்களுடைய சிவனைப் போற்றுகிறது.`,
      },
      {
        tamil: `வாக்ஷ்ரோத்ரநேத்ராங்க்⁴ரி விஹீநஜந்தோ꞉
வாக்ஷ்ரோத்ரநேத்ராங்க்⁴ரி ஸுக²ப்ரதா³ய ।
குஷ்டா²தி³ஸர்வோந்நதரோக³ஹந்த்ரே
ஶ்ரீவைத்³யநாதா²ய நம꞉ ஶிவாய ॥`,
        meaningTa: `உடல் உறுப்புகள் மற்றும் புலன்களின் நலனுக்காகவும் கடுமையான நோய்களில் இருந்து அருள் காக்கவும் வேண்டுகிறது.`,
      },
      {
        tamil: `வேதா³ந்தவேத்³யாய ஜக³ந்மயாய
யோகீ³ஶ்வரத்⁴யேயபதா³ம்பு³ஜாய ।
த்ரிமூர்திரூபாய ஸஹஸ்ரநாம்நே
ஶ்ரீவைத்³யநாதா²ய நம꞉ ஶிவாய ॥`,
        meaningTa: `வேதாந்தத்தால் அறியப்படும், உலகமெங்கும் நிறைந்த, யோகிகள் தியானிக்கும் பரம்பொருளை வணங்குகிறது.`,
      },
      {
        tamil: `ஸ்வதீர்த²ம்ருத்³ப⁴ஸ்மப்⁴ருதாங்க³பா⁴ஜாம்
பிஶாசது³꞉கா²ர்திப⁴யாபஹாய ।
ஆத்மஸ்வரூபாய ஶரீரபா⁴ஜாம்
ஶ்ரீவைத்³யநாதா²ய நம꞉ ஶிவாய ॥`,
        meaningTa: `துயரம் மற்றும் அச்சங்களைப் போக்கி, உயிர்களின் உள்ளார்ந்த ஆத்மசொரூபமாக இருக்கும் சிவனை வணங்குகிறது.`,
      },
      {
        tamil: `ஶ்ரீநீலகண்டா²ய வ்ருஷத்⁴வஜாய
ஸ்ரக்க³ந்த⁴ப⁴ஸ்மாத்³யபி⁴ஶோபி⁴தாய ।
ஸுபுத்ரதா³ராதி³ ஸுபா⁴க்³யதா³ய
ஶ்ரீவைத்³யநாதா²ய நம꞉ ஶிவாய ॥`,
        meaningTa: `நீலகண்டனாகவும் ரிஷபக் கொடியுடையவராகவும் விளங்கும் சிவனிடம் குடும்ப நலம் மற்றும் மங்களத்தை வேண்டுகிறது.`,
      },
      {
        tamil: `பா³லாம்பி³கேஶ வைத்³யேஶ ப⁴வரோக³ஹரேதி ச ।
ஜபேந்நாமத்ரயம் நித்யம் மஹாரோக³நிவாரணம் ॥`,
        meaningTa: `இது நிறைவுப் பாடல்; பாலாம்பிகேசர், வைத்தியேசர், பவரோகஹரர் என்ற திருநாமங்களைப் பக்தியுடன் நினைவுகூரும் மரபைச் சொல்கிறது.`,
      },
    ],
  },
  {
    id: "runa-vimochana-ganapati",
    slug: "runa-vimochana-ganapati-stotram-tamil",
    type: "traditional-stuti",
    titleTa: "ருண விமோசன கணபதி ஸ்தோத்ரம் - தமிழ் வரிகள் & பொருள்",
    titleEn: "Runa Vimochana Ganapati Stotram",
    deity: "vinayagar",
    shortIntroTa: "“நமாமி ருணமுக்தயே” என்ற வேண்டுதலுடன் நிறைவடையும் ருண விமோசன கணபதி ஸ்தோத்ரம், கடன் மற்றும் பொறுப்புகளால் உருவாகும் மனச்சுமையிலிருந்து விடுதலை வேண்டி விநாயகரை வணங்கும் பாரம்பரிய ஸ்தோத்திரமாகப் போற்றப்படுகிறது. இதை நிதி ஆலோசனை அல்லது கடன் தீர்வுக்கான உத்தரவாதமாக அல்லாமல், பக்தி மற்றும் மனநிலைத்தன்மைக்கான ஆன்மீகப் பாராயணமாக வழங்க வேண்டும்.",
    occasionTa: "காலை பூஜை • விநாயகர் வழிபாடு • சதுர்த்தி • புதிய முயற்சிகளுக்கு முன் மனதை ஒருமுகப்படுத்தும் நேரம்",
    originTa: "பாரம்பரிய கணபதி ஸ்தோத்திரம். பலஸ்ருதி பாரம்பரிய நூல் கூறும் ஆன்மீகப் பலனாகவே வழங்கப்படுகிறது.",
    youtubeVideoId: "NcxfcQoWM58",
    pdfUrl: "/downloads/03_Runa_Vimochana_Ganapati_Stotram_Tamil.pdf",
    keywords: ["ருண விமோசன கணபதி", "runa vimochana", "ganapati stotram", "விநாயகர்"],
    seoTitle: "ருண விமோசன கணபதி ஸ்தோத்ரம் தமிழ் | கடன் சுமை வேண்டுதல்",
    seoDescription: "ருண விமோசன கணபதி ஸ்தோத்ரம் தமிழ் எழுத்து, எளிய பொருள், வீடியோ மற்றும் mobile PDF. கடன்/பணச்சுமையில் மனநிம்மதி வேண்டிய பக்திப் பாராயணம்.",
    disclaimerTa: "ஆன்மீக பாராயணம் நிதி ஆலோசனை, கடன் மறுசீரமைப்பு அல்லது முதலீட்டு ஆலோசனைக்கு மாற்றாக அல்ல. நடைமுறை நிதித் திட்டமிடலையும் தொடருங்கள்.",
    relatedIds: ["ganesha-pancharatnam", "vinayagar-potri-108", "vinayagar-mantras"],
    verses: [
      {
        tamil: `ஸ்மராமி தே³வதே³வேஶம் வக்ரதுண்ட³ம் மஹாப³லம் ।
ஷட³க்ஷரம் க்ருபாஸிந்து⁴ம் நமாமி ருணமுக்தயே ॥`,
        meaningTa: `கருணைக் கடலான வக்கிரதுண்ட மகாபல கணபதியை நினைத்து, சுமைகளிலிருந்து விடுதலை வேண்டுகிறோம்.`,
      },
      {
        tamil: `ஏகாக்ஷரம் ஹ்யேகத³ந்தம் ஏகம் ப்³ரஹ்ம ஸநாதநம் ।
ஏகமேவாத்³விதீயம் ச நமாமி ருணமுக்தயே ॥`,
        meaningTa: `ஏகதந்தனாகவும் ஆதியற்ற பரம்பொருளாகவும் கணபதியைத் துதிக்கிறது.`,
      },
      {
        tamil: `மஹாக³ணபதிம் தே³வம் மஹாஸத்த்வம் மஹாப³லம் ।
மஹாவிக்⁴நஹரம் ஶம்போ⁴꞉ நமாமி ருணமுக்தயே ॥`,
        meaningTa: `பெரும் விக்னங்களை அகற்றும் மகாகணபதியை வணங்கி விடுதலை வேண்டுகிறது.`,
      },
      {
        tamil: `க்ருஷ்ணாம்ப³ரம் க்ருஷ்ணவர்ணம்
க்ருஷ்ணக³ந்தா⁴நுலேபநம் ।
க்ருஷ்ணஸர்போபவீதம் ச நமாமி ருணமுக்தயே ॥`,
        meaningTa: `கருநிற அலங்காரங்களுடன் வர்ணிக்கப்படும் கணபதியின் திருவுருவத்தை தியானிக்கிறது.`,
      },
      {
        tamil: `ரக்தாம்ப³ரம் ரக்தவர்ணம் ரக்தக³ந்தா⁴நுலேபநம் ।
ரக்தபுஷ்பப்ரியம் தே³வம் நமாமி ருணமுக்தயே ॥`,
        meaningTa: `சிவப்பு ஆடை, வாசனை மற்றும் பூக்களை விரும்பும் தெய்வ வடிவில் கணபதியைத் துதிக்கிறது.`,
      },
      {
        tamil: `பீதாம்ப³ரம் பீதவர்ணம் பீதக³ந்தா⁴நுலேபநம் ।
பீதபுஷ்பப்ரியம் தே³வம் நமாமி ருணமுக்தயே ॥`,
        meaningTa: `மஞ்சள் நிறத்தின் மங்கள வடிவில் கணபதியை நினைத்து வேண்டுகிறது.`,
      },
      {
        tamil: `தூ⁴ம்ராம்ப³ரம் தூ⁴ம்ரவர்ணம் தூ⁴ம்ரக³ந்தா⁴நுலேபநம் ।
ஹோமதூ⁴மப்ரியம் தே³வம் நமாமி ருணமுக்தயே ॥`,
        meaningTa: `ஹோமத் தூபம் மற்றும் தூம்ர வடிவுடன் தொடர்புபடுத்தப்பட்ட கணபதியைத் துதிக்கிறது.`,
      },
      {
        tamil: `பா²லநேத்ரம் பா²லசந்த்³ரம் பாஶாங்குஶத⁴ரம் விபு⁴ம் ।
சாமராளங்க்ருதம் தே³வம் நமாமி ருணமுக்தயே ॥`,
        meaningTa: `பாசம், அங்குசம் தாங்கிய தெய்வ வடிவில் கணபதியை வணங்கி மனச்சுமை நீங்க வேண்டுகிறது.`,
      },
      {
        tamil: `இத³ம் த்வ்ருணஹரம் ஸ்தோத்ரம் ஸந்த்⁴யாயாம் ய꞉ படே²ந்நர꞉
।
ஷண்மாஸாப்⁴யந்தரேணைவ ருணமுக்தோ ப⁴விஷ்யதி ॥`,
        meaningTa: `இது பலஸ்ருதி; பாரம்பரிய நூல் தொடர்ச்சியான பாராயணத்தின் பலனை இவ்வாறு கூறுகிறது. இதை நிதி முடிவுக்கான உறுதிமொழியாகக் கருதக்கூடாது.`,
      },
    ],
  },
  {
    id: "kanakadhara-stotram",
    slug: "kanakadhara-stotram-tamil-lyrics-meaning",
    type: "traditional-stuti",
    titleTa: "கனகதாரா ஸ்தோத்திரம் - 18 பாடல்கள் தமிழ் எழுத்து & பொருள்",
    titleEn: "Kanakadhara Stotram (18 Slokas)",
    deity: "lakshmi",
    shortIntroTa: "கனகதாரா ஸ்தோத்திரம், மகாலட்சுமியின் கருணை மற்றும் மங்களக் கடாட்சத்தைப் போற்றும் புகழ்பெற்ற ஸ்தோத்திரமாகும். பல பதிப்புகளில் பாடல்களின் எண்ணிக்கையும் வரிசையும் மாறுபடும்; தெய்வீக ஓசை வீடியோவில் பயன்படுத்தப்பட்ட 18-பாடல் பதிப்பை இந்தப் பக்கத்தின் முதன்மை உரையாக வைத்திருக்கிறோம். செல்வ வளம் பற்றிய குறிப்புகள் பக்தி வேண்டுதலாக மட்டுமே எழுதப்பட்டுள்ளன.",
    occasionTa: "வெள்ளிக்கிழமை • மகாலட்சுமி பூஜை • காலை/மாலை பக்தி நேரம் • குடும்பத்துடன் பாராயணம்",
    originTa: "ஆதி சங்கரருக்கு உரியதாகப் போற்றப்படும் ஸ்தோத்திரம். தெய்வீக ஓசை 18-பாடல் பதிப்பு.",
    youtubeVideoId: "3MsbO2WlUls",
    pdfUrl: "/downloads/04_Kanakadhara_Stotram_18_Tamil.pdf",
    keywords: ["கனகதாரா", "kanakadhara", "lakshmi", "மகாலட்சுமி", "18 slokas"],
    seoTitle: "கனகதாரா ஸ்தோத்திரம் தமிழ் வரிகள் & பொருள் | 18 Slokas",
    seoDescription: "ஆதி சங்கரரின் கனகதாரா ஸ்தோத்திரம் - தெய்வீக ஓசை பயன்படுத்திய 18-பாடல் பதிப்பு, தமிழ் எழுத்து, எளிய பொருள், வீடியோ மற்றும் PDF.",
    disclaimerTa: "செல்வ வளம் பற்றிய குறிப்புகள் பக்தி வேண்டுதலாக மட்டுமே. உத்தரவாதமான பொருளாதார முடிவுகள் உரிமை கோரப்படுவதில்லை.",
    relatedIds: ["mahalakshmi-ashtakam", "mahalakshmi-song"],
    verses: [
      {
        tamil: `அங்க³ம் ஹரே꞉ புலகபூ⁴ஷணமாஶ்ரயந்தீ
ப்⁴ருங்கா³ங்க³நேவ முகுலாப⁴ரணம் தமாலம் ।
அங்கீ³க்ருதாகி²லவிபூ⁴திரபாங்க³ளீலா
மாங்க³ல்யதா³ஸ்து மம மங்க³ளதே³வதாயா꞉ ॥ 1 ॥`,
        meaningTa: `மகாலட்சுமியின் கடைக்கண் பார்வை திருமாலின் திருமேனியில் விளங்குவது போல, அவளது மங்களக் கடாட்சம் நமக்கும் கிடைக்க வேண்டுகிறது.`,
      },
      {
        tamil: `முக்³தா⁴ முஹுர்வித³த⁴தீ வத³நே முராரே꞉
ப்ரேமத்ரபாப்ரணிஹிதாநி க³தாக³தாநி ।
மாலாத்³ருஶோர்மது⁴கரீவ மஹோத்பலே யா
ஸா மே ஶ்ரியம் தி³ஶது ஸாக³ரஸம்ப⁴வாயா꞉ ॥ 2 ॥`,
        meaningTa: `திருமாலை அன்புடன் நோக்கும் லட்சுமியின் பார்வை தாமரையில் வண்டுபோல் அசைகிறது; அந்த பார்வை நன்மையை அருள வேண்டுகிறது.`,
      },
      {
        tamil: `விஶ்வாமரேந்த்³ரபத³விப்⁴ரமதா³நத³க்ஷ-
-மாநந்த³ஹேதுரதி⁴கம் முரவித்³விஷோ(அ)பி ।
ஈஷந்நிஷீத³து மயி க்ஷணமீக்ஷணார்த²-
-மிந்தீ³வரோத³ரஸஹோத³ரமிந்தி³ராயா꞉ ॥ 3 ॥`,
        meaningTa: `தேவர்களின் உயர்வுக்கும் மகிழ்ச்சிக்கும் காரணமான லட்சுமியின் கருணைப் பார்வை ஒரு கணம் நம்மீதும் நிலைக்க வேண்டுகிறது.`,
      },
      {
        tamil: `ஆமீலிதாக்ஷமதி⁴க³ம்ய முதா³ முகுந்த³-
-மாநந்த³கந்த³மநிமேஷமநங்க³தந்த்ரம் ।
ஆகேகரஸ்தி²தகநீநிகபக்ஷ்மநேத்ரம்
பூ⁴த்யை ப⁴வேந்மம பு⁴ஜங்க³ஶயாங்க³நாயா꞉ ॥ 4 ॥`,
        meaningTa: `ஆதிசேஷன் மீது உறங்கும் திருமாலின் துணைவியான லட்சுமியின் பார்வை நமக்கு வளமும் நலனும் தர வேண்டுகிறது.`,
      },
      {
        tamil: `பா³ஹ்வந்தரே மது⁴ஜித꞉ ஶ்ரிதகௌஸ்துபே⁴ யா
ஹாராவளீவ ஹரிநீலமயீ விபா⁴தி ।
காமப்ரதா³ ப⁴க³வதோ(அ)பி கடாக்ஷமாலா
கல்யாணமாவஹது மே கமலாலயாயா꞉ ॥ 5 ॥`,
        meaningTa: `கௌஸ்துபம் அணிந்த திருமாலின் மார்பில் மாலையைப் போல ஒளிரும் லட்சுமியின் கடாட்சம் மங்களம் தர வேண்டுகிறது.`,
      },
      {
        tamil: `காலாம்பு³தா³ளிலலிதோரஸி கைடபா⁴ரே-
-ர்தா⁴ராத⁴ரே ஸ்பு²ரதி யா தடித³ங்க³நேவ ।
மாதுஸ்ஸமஸ்தஜக³தாம் மஹநீயமூர்தி꞉
ப⁴த்³ராணி மே தி³ஶது பா⁴ர்க³வநந்த³நாயா꞉ ॥ 6 ॥`,
        meaningTa: `கருமேகத்தில் மின்னல்போல் திருமாலின் மார்பில் ஒளிரும் உலக அன்னையின் திருவுருவம் நன்மை தர வேண்டுகிறது.`,
      },
      {
        tamil: `ப்ராப்தம் பத³ம் ப்ரத²மத꞉ க²லு யத்ப்ரபா⁴வா-
-ந்மாங்க³ல்யபா⁴ஜி மது⁴மாதி²நி மந்மதே²ந ।
மய்யாபதேத்ததி³ஹ மந்த²ரமீக்ஷணார்த⁴ம்
மந்தா³ளஸம் ச மகராளயகந்யகாயா꞉ ॥ 7 ॥`,
        meaningTa: `திருமாலையே மயக்கமுறச் செய்யும் அன்னையின் மெல்லிய கடைக்கண் பார்வை நமக்கும் அருள வேண்டுகிறது.`,
      },
      {
        tamil: `த³த்³யாத்³த³யாநுபவநோ த்³ரவிணாம்பு³தா⁴ரா-
-மஸ்மிந்ந கிஞ்சந விஹங்க³ஶிஶௌ விஷண்ணே ।
து³ஷ்கர்மக⁴ர்மமபநீய சிராய தூ³ரம்
நாராயணப்ரணயிநீநயநாம்பு³வாஹ꞉ ॥ 8 ॥`,
        meaningTa: `வறுமை மற்றும் துயரத்தில் உள்ளவர்மீது கருணை மழை பொழியும்படி லட்சுமியின் திருக்கண்களை வேண்டுகிறது.`,
      },
      {
        tamil: `இஷ்டாவிஶிஷ்டமதயோ(அ)பி யயா த³யார்த்³ர-
-த்³ருஷ்ட்யா த்ரிவிஷ்டபபத³ம் ஸுலப⁴ம் லப⁴ந்தே ।
த்³ருஷ்டி꞉ ப்ரஹ்ருஷ்டகமலோத³ரதீ³ப்திரிஷ்டாம்
புஷ்டிம் க்ருஷீஷ்ட மம புஷ்கரவிஷ்டராயா꞉ ॥ 9 ॥`,
        meaningTa: `கருணை நிறைந்த பார்வையால் உயர்ந்த நிலையை அடையச் செய்யும் லட்சுமி நம் வாழ்வில் தேவையான புஷ்டி மற்றும் நன்மையை வளர்க்க வேண்டுகிறது.`,
      },
      {
        tamil: `கீ³ர்தே³வதேதி க³ருட³த்⁴வஜஸுந்த³ரீதி
ஶாகம்ப⁴ரீதி ஶஶிஶேக²ரவல்லபே⁴தி ।
ஸ்ருஷ்டிஸ்தி²திப்ரளயகேலிஷு ஸம்ஸ்தி²தாயை
தஸ்யை நமஸ்த்ரிபு⁴வநைககு³ரோஸ்தருண்யை ॥ 10 ॥`,
        meaningTa: `சரஸ்வதி, லட்சுமி, சக்தி போன்ற பல தெய்வீக வடிவங்களில் படைப்பு-காப்பு-அழிவில் நிறைந்திருக்கும் பராசக்தியை வணங்குகிறது.`,
      },
      {
        tamil: `ஶ்ருத்யை நமோ(அ)ஸ்து ஶுப⁴கர்மப²லப்ரஸூத்யை
ரத்யை நமோ(அ)ஸ்து ரமணீயகு³ணார்ணவாயை ।
ஶக்த்யை நமோ(அ)ஸ்து ஶதபத்ரநிகேதநாயை
புஷ்ட்யை நமோ(அ)ஸ்து புருஷோத்தமவல்லபா⁴யை ॥ 11 ॥`,
        meaningTa: `வேதம், மங்களச் செயல்களின் பலன், அன்பு, சக்தி, புஷ்டி ஆகிய அனைத்தாக விளங்கும் லட்சுமியை வணங்குகிறது.`,
      },
      {
        tamil: `நமோ(அ)ஸ்து நாலீகநிபா⁴நநாயை
நமோ(அ)ஸ்து து³க்³தோ⁴த³தி⁴ஜந்மபூ⁴ம்யை ।
நமோ(அ)ஸ்து ஸோமாம்ருதஸோத³ராயை
நமோ(அ)ஸ்து நாராயணவல்லபா⁴யை ॥ 12 ॥`,
        meaningTa: `தாமரை முகமுடைய, பாற்கடலில் தோன்றிய, நாராயணனின் பிரியமான திருமகளை வணங்குகிறது.`,
      },
      {
        tamil: `ஸம்பத்கராணி ஸகலேந்த்³ரியநந்த³நாநி
ஸாம்ராஜ்யதா³நவிப⁴வாநி ஸரோருஹாக்ஷி ।
த்வத்³வந்த³நாநி து³ரிதாஹரணோத்³யதாநி
மாமேவ மாதரநிஶம் கலயந்து மாந்யே ॥ 13 ॥`,
        meaningTa: `தாமரைக் கண்களுடைய அன்னையை வணங்குவது மனநிறைவு, நன்மை மற்றும் துன்பநீக்கத்தை அருளட்டும் என வேண்டுகிறது.`,
      },
      {
        tamil: `யத்கடாக்ஷஸமுபாஸநாவிதி⁴꞉
ஸேவகஸ்ய ஸகலார்த²ஸம்பத³꞉ ।
ஸந்தநோதி வசநாங்க³மாநஸை-
-ஸ்த்வாம் முராரிஹ்ருத³யேஶ்வரீம் ப⁴ஜே ॥ 14 ॥`,
        meaningTa: `சொல், செயல், மனம் மூன்றாலும் திருமாலின் இதயராணியான லட்சுமியை பக்தியுடன் வழிபடுகிறோம்.`,
      },
      {
        tamil: `ஸரஸிஜநிலயே ஸரோஜஹஸ்தே
த⁴வளதமாம்ஶுகக³ந்த⁴மால்யஶோபே⁴ ।
ப⁴க³வதி ஹரிவல்லபே⁴ மநோஜ்ஞே
த்ரிபு⁴வநபூ⁴திகரி ப்ரஸீத³ மஹ்யம் ॥ 15 ॥`,
        meaningTa: `தாமரையில் வீற்றிருந்து தாமரை தாங்கும், உலகிற்கு நலன் தரும் ஹரிவல்லபையை எங்கள்மீது கருணை கொள்ள வேண்டுகிறது.`,
      },
      {
        tamil: `தி³க்³க⁴ஸ்திபி⁴꞉ கநககும்ப⁴முகா²வஸ்ருஷ்ட-
-ஸ்வர்வாஹிநீவிமலசாருஜலப்லுதாங்கீ³ம் ।
ப்ராதர்நமாமி ஜக³தாம் ஜநநீமஶேஷ-
-லோகாதி⁴நாத²க்³ருஹிணீமம்ருதாப்³தி⁴புத்ரீம் ॥ 16 ॥`,
        meaningTa: `பொற்கலச நீரால் அபிஷேகம் பெறும் உலக அன்னையும் அமுதக் கடலின் மகளுமான லட்சுமியை காலை வணங்குகிறது.`,
      },
      {
        tamil: `கமலே கமலாக்ஷவல்லபே⁴ த்வம்
கருணாபூரதரங்கி³தைரபாங்கை³꞉ ।
அவலோகய மாமகிஞ்சநாநாம்
ப்ரத²மம் பாத்ரமக்ருத்ரிமம் த³யாயா꞉ ॥ 17 ॥`,
        meaningTa: `கமலனின் பிரியமான கமலையே, எதுவுமற்ற என்மீது இயல்பான கருணைப் பார்வையைச் செலுத்த வேண்டும் என வேண்டுகிறது.`,
      },
      {
        tamil: `ஸ்துவந்தி யே ஸ்துதிபி⁴ரமூபி⁴ரந்வஹம்
த்ரயீமயீம் த்ரிபு⁴வநமாதரம் ரமாம் ।
கு³ணாதி⁴கா கு³ருதரபா⁴க்³யபா⁴ஜிநோ
ப⁴வந்தி தே பு⁴வி பு³த⁴பா⁴விதாஶயா꞉ ॥ 18 ॥`,
        meaningTa: `மூன்று உலகங்களின் அன்னையான ரமையை தினமும் பக்தியுடன் போற்றுவோர் நல்ல குணங்களும் மங்களமான வாழ்வும் பெறுவர் என்று பலஸ்ருதி கூறுகிறது.`,
      },
    ],
  },
  {
    id: "mahalakshmi-ashtakam",
    slug: "mahalakshmi-ashtakam-tamil-lyrics",
    type: "traditional-stuti",
    titleTa: "மகாலட்சுமி அஷ்டகம் - நமஸ்தேஸ்து மகாமாயே தமிழ் வரிகள்",
    titleEn: "Mahalakshmi Ashtakam",
    deity: "lakshmi",
    shortIntroTa: "“நமஸ்தேஸ்து மகாமாயே” என்று தொடங்கும் மகாலட்சுமி அஷ்டகம், திருமகளின் சக்தி, கருணை, ஞானம் மற்றும் மங்களத்தைப் போற்றும் எட்டு பாடல்களைக் கொண்ட ஸ்தோத்திரம். வெள்ளிக்கிழமை, லட்சுமி பூஜை மற்றும் தினசரி பக்தி நேரங்களில் பாராயணம் செய்ய ஏற்றதாக பக்தர்கள் கருதுகிறார்கள்.",
    occasionTa: "வெள்ளிக்கிழமை • மகாலட்சுமி பூஜை • காலை/மாலை பக்தி நேரம் • குடும்பத்துடன் பாராயணம்",
    originTa: "பாரம்பரிய மகாலட்சுமி அஷ்டகம். பலஸ்ருதி பாரம்பரிய நம்பிக்கையாக அறிமுகப்படுத்தப்படுகிறது.",
    youtubeVideoId: "UTeB_vXfsho",
    pdfUrl: "/downloads/05_Mahalakshmi_Ashtakam_Tamil.pdf",
    keywords: ["மகாலட்சுமி அஷ்டகம்", "mahalakshmi ashtakam", "namastestu mahamaye", "லட்சுமி"],
    seoTitle: "மகாலட்சுமி அஷ்டகம் தமிழ் | Namastestu Mahamaye Lyrics",
    seoDescription: "நமஸ்தேஸ்து மகாமாயே - மகாலட்சுமி அஷ்டகம் தமிழ் எழுத்து, எளிய பொருள், தெய்வீக ஓசை வீடியோ மற்றும் mobile PDF.",
    relatedIds: ["kanakadhara-stotram", "mahalakshmi-song"],
    verses: [
      {
        tamil: `நமஸ்தே(அ)ஸ்து மஹாமாயே ஶ்ரீபீடே² ஸுரபூஜிதே ।
ஶங்க²சக்ரக³தா³ஹஸ்தே மஹாலக்ஷ்மி நமோ(அ)ஸ்து தே ॥ 1 ॥`,
        meaningTa: `தேவர்களால் பூஜிக்கப்படும், சங்கு, சக்கரம், கதா தாங்கும் மகாலட்சுமியை வணங்குகிறோம்.`,
      },
      {
        tamil: `நமஸ்தே க³ருடா³ரூடே⁴ கோலாஸுரப⁴யங்கரி ।
ஸர்வபாபஹரே தே³வி மஹாலக்ஷ்மி நமோ(அ)ஸ்து தே ॥ 2 ॥`,
        meaningTa: `கருட வாகனத்தில் விளங்கும், தீமையை அகற்றி காக்கும் மகாலட்சுமியை வணங்குகிறது.`,
      },
      {
        tamil: `ஸர்வஜ்ஞே ஸர்வவரதே³ ஸர்வது³ஷ்டப⁴யங்கரி ।
ஸர்வது³꞉க²ஹரே தே³வி மஹாலக்ஷ்மி நமோ(அ)ஸ்து தே ॥ 3 ॥`,
        meaningTa: `அறிவும் வரமும் அருளும், துயரங்களைப் போக்கும் அன்னையை வணங்குகிறது.`,
      },
      {
        tamil: `ஸித்³தி⁴பு³த்³தி⁴ப்ரதே³ தே³வி பு⁴க்திமுக்திப்ரதா³யிநி ।
மந்த்ரமூர்தே ஸதா³ தே³வி மஹாலக்ஷ்மி நமோ(அ)ஸ்து தே ॥ 4
॥`,
        meaningTa: `சித்தி, புத்தி, வாழ்வின் நலனும் ஆன்மீக விடுதலையும் அருளும் தேவியைப் போற்றுகிறது.`,
      },
      {
        tamil: `ஆத்³யந்தரஹிதே தே³வி ஆத்³யஶக்தி மஹேஶ்வரி ।
யோக³ஜே யோக³ஸம்பூ⁴தே மஹாலக்ஷ்மி நமோ(அ)ஸ்து தே ॥
5॥`,
        meaningTa: `ஆதி-அந்தமற்ற ஆதிசக்தியாக விளங்கும் மகேஸ்வரியை வணங்குகிறது.`,
      },
      {
        tamil: `ஸ்தூ²லஸூக்ஷ்மமஹாரௌத்³ரே மஹாஶக்தே மஹோத³ரே ।
மஹாபாபஹரே தே³வி மஹாலக்ஷ்மி நமோ(அ)ஸ்து தே ॥ 6 ॥`,
        meaningTa: `ஸ்தூலமும் சூட்சுமமும் என எல்லா நிலைகளிலும் நிறைந்த பெரும் சக்தியை வணங்குகிறது.`,
      },
      {
        tamil: `பத்³மாஸநஸ்தி²தே தே³வி பரப்³ரஹ்மஸ்வரூபிணி ।
பரமேஶி ஜக³ந்மாதர்மஹாலக்ஷ்மி நமோ(அ)ஸ்து தே ॥ 7 ॥`,
        meaningTa: `தாமரையில் அமர்ந்த உலக அன்னையும் பரம்பொருளின் வடிவுமான மகாலட்சுமியை வணங்குகிறது.`,
      },
      {
        tamil: `ஶ்வேதாம்ப³ரத⁴ரே தே³வி நாநாலங்காரபூ⁴ஷிதே ।
ஜக³த்ஸ்தி²தே ஜக³ந்மாதர்மஹாலக்ஷ்மி நமோ(அ)ஸ்து தே ॥ 8
॥`,
        meaningTa: `வெண் ஆடையுடன் அழகிய அலங்காரங்களில் விளங்கும் உலக அன்னையை வணங்குகிறது.`,
      },
      {
        tamil: `மஹாலக்ஷ்ம்யஷ்டகம் ஸ்தோத்ரம் ய꞉ படே²த்³ப⁴க்திமாந்நர꞉ ।
ஸர்வஸித்³தி⁴மவாப்நோதி ராஜ்யம் ப்ராப்நோதி ஸர்வதா³ ॥`,
        meaningTa: `இது பலஸ்ருதி. பக்தியுடன் பாராயணம் செய்வதின் ஆன்மீக பலனை பாரம்பரியம் போற்றுகிறது.`,
      },
      {
        tamil: `ஏககாலம் படே²ந்நித்யம் மஹாபாபவிநாஶநம் ।
த்³விகாலம் ய꞉ படே²ந்நித்யம் த⁴நதா⁴ந்யஸமந்வித꞉ ॥`,
        meaningTa: `தினசரி பாராயணத்தின் பலனைப் பற்றிய பாரம்பரியக் குறிப்பு.`,
      },
      {
        tamil: `த்ரிகாலம் ய꞉ படே²ந்நித்யம் மஹாஶத்ருவிநாஶநம் ।
மஹாலக்ஷ்மீர்ப⁴வேந்நித்யம் ப்ரஸந்நா வரதா³ ஶுபா⁴ ॥`,
        meaningTa: `மகாலட்சுமி அருள் மற்றும் மங்களத்தை வேண்டிய பலஸ்ருதி நிறைவு.`,
      },
    ],
  },
  {
    id: "sri-venkatesa-stotram",
    slug: "sri-venkatesa-stotram-tamil-lyrics",
    type: "traditional-stuti",
    titleTa: "ஸ்ரீ வேங்கடேச ஸ்தோத்திரம் - 11 ஸ்லோகங்கள் தமிழ் வரிகளுடன்",
    titleEn: "Sri Venkatesa Stotram",
    deity: "vishnu",
    shortIntroTa: "திருமலை ஸ்ரீ வேங்கடேசப் பெருமானைப் போற்றும் இந்த ஸ்தோத்திரம் “கமலாகுசசூசுக குங்குமதோ” என்று தொடங்குகிறது. தெய்வீக ஓசை வீடியோ 11 ஸ்லோகங்களையும் தமிழ் எழுத்தில் வழங்குகிறது. புரட்டாசி வழிபாட்டிற்கு சிறப்பாகப் பொருந்தினாலும், தினசரி காலை அல்லது மாலை பக்தி நேரத்திலும் பாராயணம் செய்யலாம்.",
    occasionTa: "காலை/மாலை பெருமாள் வழிபாடு • புரட்டாசி • சனிக்கிழமை • தினசரி நாமஸ்மரணம்/பக்தி நேரம்",
    originTa: "ஸ்ரீ வேங்கடேசப் பெருமாள் ஸ்தோத்திரம் — 11 ஸ்லோகங்கள்.",
    youtubeVideoId: "OnqJvI_rMUE",
    pdfUrl: "/downloads/06_Sri_Venkatesa_Stotram_Tamil.pdf",
    keywords: ["ஸ்ரீ வேங்கடேச ஸ்தோத்திரம்", "venkatesa stotram", "perumal", "புரட்டாசி", "திருப்பதி"],
    seoTitle: "ஸ்ரீ வேங்கடேச ஸ்தோத்திரம் தமிழ் வரிகள் | Purattasi Perumal",
    seoDescription: "கமலாகுசசூசுக குங்குமதோ என்று தொடங்கும் 11 ஸ்ரீ வேங்கடேச ஸ்லோகங்கள் - தமிழ் எழுத்து, எளிய பொருள், வீடியோ மற்றும் PDF.",
    relatedIds: ["vishnu-108-names", "govinda-namavali", "kanneerodu-vandhene"],
    verses: [
      {
        tamil: `கமலாகுசசூசுககுங்குமதோ
நியதாருணிதாதுலநீலதநோ ।
கமலாயதலோசந லோகபதே
விஜயீப⁴வ வேங்கடஶைலபதே ॥ 1 ॥`,
        meaningTa: `திருமகளின் குங்குமம் பதிந்த திருமேனியுடன், தாமரை போன்ற கண்களுடைய வேங்கடமலை நாதரை போற்றுகிறது.`,
      },
      {
        tamil: `ஸசதுர்முக²ஷண்முக²பஞ்சமுக²
ப்ரமுகா²கி²லதை³வதமௌளிமணே ।
ஶரணாக³தவத்ஸல ஸாரநிதே⁴
பரிபாலய மாம் வ்ருஷஶைலபதே ॥ 2 ॥`,
        meaningTa: `பிரம்மா, முருகன், சிவன் உள்ளிட்ட தெய்வங்களால் போற்றப்படும், சரணடைந்தவர்களை நேசிக்கும் பெருமாளிடம் காப்பை வேண்டுகிறது.`,
      },
      {
        tamil: `அதிவேலதயா தவ து³ர்விஷஹை-
-ரநுவேலக்ருதைரபராத⁴ஶதை꞉ ।
ப⁴ரிதம் த்வரிதம் வ்ருஷஶைலபதே
பரயா க்ருபயா பரிபாஹி ஹரே ॥ 3 ॥`,
        meaningTa: `தவறுகள் பல செய்தாலும் கருணையுடன் காக்க வேண்டி இறைவனை சரணடைகிறது.`,
      },
      {
        tamil: `அதி⁴வேங்கடஶைலமுதா³ரமதே-
-ர்ஜநதாபி⁴மதாதி⁴கதா³நரதாத் ।
பரதே³வதயா க³தி³தாந்நிக³மை꞉
கமலாத³யிதாந்ந பரம் கலயே ॥ 4 ॥`,
        meaningTa: `வேங்கடமலையில் அருள்புரியும் திருமகளின் நாதனே உயர்ந்த பரம்பொருள் எனப் போற்றுகிறது.`,
      },
      {
        tamil: `கலவேணுரவாவஶகோ³பவதூ⁴-
-ஶதகோடிவ்ருதாத்ஸ்மரகோடிஸமாத் ।
ப்ரதிவல்லவிகாபி⁴மதாத்ஸுக²தா³த்
வஸுதே³வஸுதாந்ந பரம் கலயே ॥ 5 ॥`,
        meaningTa: `கிருஷ்ண வடிவில் இனிய வேணு இசையால் கோபியர்களை கவர்ந்த வாசுதேவனின் மகனை பரம்பொருளாக போற்றுகிறது.`,
      },
      {
        tamil: `அபி⁴ராமகு³ணாகர தா³ஶரதே²
ஜக³தே³கத⁴நுர்த⁴ர தீ⁴ரமதே ।
ரகு⁴நாயக ராம ரமேஶ விபோ⁴
வரதோ³ ப⁴வ தே³வ த³யாஜலதே⁴ ॥ 6 ॥`,
        meaningTa: `ராம அவதாரத்தின் நல்ல குணங்கள், வீரமும் கருணையும் கொண்ட பரம்பொருளிடம் வரம் வேண்டுகிறது.`,
      },
      {
        tamil: `அவநீதநயா கமநீயகரம்
ரஜநீகரசாருமுகா²ம்பு³ருஹம் ।
ரஜநீசரராஜதமோமிஹிரம்
மஹநீயமஹம் ரகு⁴ராமமயே ॥ 7 ॥`,
        meaningTa: `சீதையின் நாதனாக, ராவணன் எனும் இருளை அகற்றிய ரகுராமனை நினைக்கிறது.`,
      },
      {
        tamil: `ஸுமுக²ம் ஸுஹ்ருத³ம் ஸுலப⁴ம் ஸுக²த³ம்
ஸ்வநுஜம் ச ஸுகாயமமோக⁴ஶரம் ।
அபஹாய ரகூ⁴த்³வஹமந்யமஹம்
ந கத²ஞ்சந கஞ்சந ஜாது ப⁴ஜே ॥ 8 ॥`,
        meaningTa: `அன்பான, எளிதில் அணுகக்கூடிய, நலம் தரும் ரகுநாதனைத் தவிர வேறு சரணம் இல்லை எனப் பக்தி தெரிவிக்கிறது.`,
      },
      {
        tamil: `விநா வேங்கடேஶம் ந நாதோ² ந நாத²꞉
ஸதா³ வேங்கடேஶம் ஸ்மராமி ஸ்மராமி ।
ஹரே வேங்கடேஶ ப்ரஸீத³ ப்ரஸீத³
ப்ரியம் வேங்கடேஶ ப்ரயச்ச² ப்ரயச்ச² ॥ 9 ॥`,
        meaningTa: `வேங்கடேசனைத் தவிர எனக்கு வேறு நாதன் இல்லை; எப்போதும் அவரையே நினைத்து கருணையை வேண்டுகிறேன்.`,
      },
      {
        tamil: `அஹம் தூ³ரதஸ்தே பதா³ம்போ⁴ஜயுக்³ம-
-ப்ரணாமேச்ச²யா(ஆ)க³த்ய ஸேவாம் கரோமி ।
ஸக்ருத்ஸேவயா நித்யஸேவாப²லம் த்வம்
ப்ரயச்ச² ப்ரயச்ச² ப்ரபோ⁴ வேங்கடேஶ ॥ 10 ॥`,
        meaningTa: `தூரத்திலிருந்து வந்த பக்தன் திருவடிகளை வணங்கி சேவை செய்வதை ஏற்றருள வேண்டுகிறது.`,
      },
      {
        tamil: `அஜ்ஞாநிநா மயா தோ³ஷாநஶேஷாந்விஹிதாந் ஹரே ।
க்ஷமஸ்வ த்வம் க்ஷமஸ்வ த்வம் ஶேஷஶைலஶிகா²மணே ॥ 11
॥`,
        meaningTa: `அறியாமையால் செய்த எல்லா தவறுகளையும் மன்னிக்க வேண்டி சேஷாசல நாதனை சரணடைகிறது.`,
      },
    ],
  },
  {
    id: "madhurashtakam",
    slug: "madhurashtakam-tamil-lyrics-meaning",
    type: "traditional-stuti",
    titleTa: "மதுராஷ்டகம் - அதரம் மதுரம் தமிழ் வரிகள் & எளிய பொருள்",
    titleEn: "Madhurashtakam",
    deity: "vishnu",
    shortIntroTa: "ஸ்ரீ வல்லபாசாரியருக்கு உரியதாகப் போற்றப்படும் மதுராஷ்டகம், கண்ணனின் திருவுருவம், புன்னகை, குழல், நடை, லீலைகள், யமுனை என அனைத்தும் “மதுரம்” - இனிமை - என்று பாடும் எட்டு பாடல்களைக் கொண்ட பக்தி ஸ்தோத்திரம். கிருஷ்ண ஜெயந்தி காலத்தில் மட்டுமல்லாமல் தினசரி கிருஷ்ண பக்திக்கும் ஏற்றது.",
    occasionTa: "கிருஷ்ண ஜெயந்தி • காலை/மாலை கிருஷ்ண வழிபாடு • தினசரி பக்தி நேரம்",
    originTa: "ஸ்ரீ வல்லபாசாரியருக்கு உரியதாகப் போற்றப்படும் மதுராஷ்டகம்.",
    youtubeVideoId: "_Lq1Va6fS6s",
    pdfUrl: "/downloads/07_Madhurashtakam_Tamil.pdf",
    keywords: ["மதுராஷ்டகம்", "madhurashtakam", "adharam madhuram", "krishna", "கிருஷ்ணர்"],
    seoTitle: "மதுராஷ்டகம் தமிழ் வரிகள் & பொருள் | Adharam Madhuram",
    seoDescription: "அதரம் மதுரம் - மதுராஷ்டகம் 8 பாடல்கள் தமிழ் எழுத்து, எளிய பொருள், கிருஷ்ண பக்தி வீடியோ மற்றும் mobile PDF.",
    relatedIds: ["vishnu-108-names", "sri-venkatesa-stotram"],
    verses: [
      {
        tamil: `அத⁴ரம் மது⁴ரம் வத³னம் மது⁴ரம்
நயனம் மது⁴ரம் ஹஸிதம் மது⁴ரம் |
ஹ்ருத³யம் மது⁴ரம் க³மனம் மது⁴ரம்
மது⁴ராதி⁴பதேரகி²லம் மது⁴ரம் || 1 ||`,
        meaningTa: `கண்ணனின் உதடு, முகம், கண்கள், புன்னகை, இதயம், நடை அனைத்தும் இனிமை என்று போற்றுகிறது.`,
      },
      {
        tamil: `வசனம் மது⁴ரம் சரிதம் மது⁴ரம்
வஸனம் மது⁴ரம் வலிதம் மது⁴ரம் |
சலிதம் மது⁴ரம் ப்⁴ரமிதம் மது⁴ரம்
மது⁴ராதி⁴பதேரகி²லம் மது⁴ரம் || 2 ||`,
        meaningTa: `அவரது சொல், செயல்கள், ஆடை, அசைவு, விளையாட்டு அனைத்திலும் தெய்வீக இனிமையை காண்கிறது.`,
      },
      {
        tamil: `வேணுர்மது⁴ரோ ரேணுர்மது⁴ர꞉
பாணிர்மது⁴ர꞉ பாதௌ³ மது⁴ரௌ |
ந்ருத்யம் மது⁴ரம் ஸக்²யம் மது⁴ரம்
மது⁴ராதி⁴பதேரகி²லம் மது⁴ரம் || 3 ||`,
        meaningTa: `கண்ணனின் குழல், பாதத் தூசி, கரங்கள், திருவடிகள், நடனம், நட்பு அனைத்தும் இனிமை.`,
      },
      {
        tamil: `கீ³தம் மது⁴ரம் பீதம் மது⁴ரம்
பு⁴க்தம் மது⁴ரம் ஸுப்தம் மது⁴ரம் |
ரூபம் மது⁴ரம் திலகம் மது⁴ரம்
மது⁴ராதி⁴பதேரகி²லம் மது⁴ரம் || 4 ||`,
        meaningTa: `அவரது பாடல், அருந்துதல், உணவு, உறக்கம், திருவுருவம், திலகம் அனைத்தும் இனிமை.`,
      },
      {
        tamil: `கரணம் மது⁴ரம் தரணம் மது⁴ரம்
ஹரணம் மது⁴ரம் ஸ்மரணம் மது⁴ரம் |
வமிதம் மது⁴ரம் ஶமிதம் மது⁴ரம்
மது⁴ராதி⁴பதேரகி²லம் மது⁴ரம் || 5 ||`,
        meaningTa: `கண்ணனின் செயல்களும் காப்பும் நினைவும்கூட பக்தருக்கு இனிமையானவை என்று கூறுகிறது.`,
      },
      {
        tamil: `கு³ஞ்ஜா மது⁴ரா மாலா மது⁴ரா
யமுனா மது⁴ரா வீசீ மது⁴ரா |
ஸலிலம் மது⁴ரம் கமலம் மது⁴ரம்
மது⁴ராதி⁴பதேரகி²லம் மது⁴ரம் || 6 ||`,
        meaningTa: `கண்ணனுடன் தொடர்புடைய மாலை, யமுனை, அதன் அலை, நீர், தாமரை அனைத்தும் இனிமை.`,
      },
      {
        tamil: `கோ³பீ மது⁴ரா லீலா மது⁴ரா
யுக்தம் மது⁴ரம் முக்தம் மது⁴ரம் |
த்³ருஷ்டம் மது⁴ரம் ஶிஷ்டம் மது⁴ரம்
மது⁴ராதி⁴பதேரகி²லம் மது⁴ரம் || 7 ||`,
        meaningTa: `கோபியர், கண்ணனின் லீலைகள் மற்றும் அவரோடு சேர்ந்த அனைத்தும் இனிமை என்று போற்றுகிறது.`,
      },
      {
        tamil: `கோ³பா மது⁴ரா கா³வோ மது⁴ரா
யஷ்டிர்மது⁴ரா ஸ்ருஷ்டிர்மது⁴ரா |
த³லிதம் மது⁴ரம் ப²லிதம் மது⁴ரம்
மது⁴ராதி⁴பதேரகி²லம் மது⁴ரம் || 8 ||`,
        meaningTa: `கோபர்கள், பசுக்கள், கையில் உள்ள கோல், படைப்பு மற்றும் விளைவு அனைத்திலும் கண்ணனின் இனிமை நிறைந்துள்ளது.`,
      },
    ],
  },
  {
    id: "abirami-16-blessings",
    slug: "abirami-ammai-pathigam-16-blessings",
    type: "traditional-stuti",
    titleTa: "அபிராமி அம்மைப் பதிகம் - பதினாறு பேறுகள் வரிகள் & பொருள்",
    titleEn: "Abirami Ammai Pathigam — 16 Blessings",
    deity: "amman",
    shortIntroTa: "அபிராமி பட்டர் அருளிய அபிராமி அம்மைப் பதிகத்தின் “கலையாத கல்வியும்…” பாடல், வாழ்வில் வேண்டப்படும் பல நலன்களை கவிதை வடிவில் வேண்டுகிறது. தெய்வீக ஓசை வீடியோ அதனுடன் “சகல செல்வங்களும் தரும்…” பாடலையும் இணைத்து பதினாறு பேறுகளின் கருத்தை எளிய தமிழில் விளக்குகிறது. இங்கு “16 குழந்தைகள்” அல்ல — “பதினாறு வகையான வாழ்வியல் நலன்கள்” என்ற பொருளே சரியானது.",
    themeTa: "பதினாறு பேறுகள்: நோயின்மை, கல்வி, தனம், தானியம், அழகு, புகழ், பெருமை, இளமை, அறிவு, சந்தானம், வலி, துணிவு, வாழ்நாள், வெற்றி, நல்ல ஊழ், நுகர்ச்சி.",
    occasionTa: "ஆடி வெள்ளி • அம்மன் வழிபாடு • குடும்ப நலம் வேண்டிய பிரார்த்தனை • தினசரி பக்தி வாசிப்பு",
    originTa: "அபிராமி பட்டர் — அபிராமி அம்மைப் பதிகம். தேர்ந்தெடுக்கப்பட்ட இரண்டு முக்கிய செய்யுட்கள்.",
    youtubeVideoId: "oNPyij7UWXA",
    pdfUrl: "/downloads/08_Abirami_Pathigam_16_Blessings_Tamil.pdf",
    keywords: ["அபிராமி", "பதினாறு பேறுகள்", "abirami", "16 blessings", "அம்மன்"],
    seoTitle: "பதினாறு பேறுகள் என்றால் என்ன? அபிராமி அம்மைப் பதிகம் வரிகள்",
    seoDescription: "“கலையாத கல்வியும்” மற்றும் “சகல செல்வங்களும்” - அபிராமி அம்மைப் பதிகம், பதினாறு பேறுகளின் எளிய விளக்கம், வீடியோ மற்றும் PDF.",
    relatedIds: ["amman-potri-108", "aigiri-nandini"],
    verses: [
      {
        tamil: `கலையாத கல்வியும் குறையாத வயதும்ஓர் கபடுவா ராத
நட்பும்
கன்றாத வளமையும் குன்றாத இளமையும் கழுபிணியி லாத
உடலும்
சலியாத மனமும்அன் பகலாத மனையியும் தவறாத சந்தா
னமும்
தாழாத கீர்த்தியும் மாறாத வார்த்தையும் தடைகள் வாராத
கொடையும்
தொலையாத நிதியமும் கோணாத கோலுமொரு துன்பமில்
லாத வாழ்வும்
துய்நின் பாதத்தில் அன்பும் உதவிப் பெரிய தொண்டரொடு
கூட்டு கண்டாய்
அலையாழி அறிதுயிலும் மாயனது தங்கையே! ஆதிகட வூரின்
வாழ்வே!
அமுதீசர் ஒருபாகம் அகலாத சுகபாணி! அருள்வாமி!
அபிராமியே!`,
        meaningTa: `மறவாத கல்வி, நீண்ட நல்வாழ்வு, உண்மையான நட்பு, வளம், ஆரோக்கியம், மனஉறுதி, நல்ல குடும்பம், சந்தானம், புகழ், நேர்மை, கொடை, நிலையான செல்வம், நீதி, துன்பமில்லா வாழ்க்கை, இறை அன்பு, நல்லோரின் தொடர்பு ஆகிய நலன்களை வேண்டுகிறது.`,
      },
      {
        tamil: `சகலசெல் வங்களுந் தரும்இமய கிரிராச தனயைமா தேவி!
நின்னைச்
சத்யமாய் நித்யமுள் ளத்தில்து திக்கும்உத் தமருக்(கு) இரங்கி
மிகவும்
அகிலமதில் நோயின்மை கல்விதன தானியம் அழகுபுகழ்
பெருமை இளமை
அறிவுசந் தானம்வலி துணிவுவாழ் நாள்வெற்றி ஆகுநல்
ஊழ்நு கர்ச்சி
தொகைதரும் பதினாறு பேறும்தந் தருளிநீ சுகானந்த
வாழ்வளிப் பாய்;
சுகிர்தகுண சாலி! பரி பாலி! அநு கூலி!திரி சூலி!மங் களவி
சாலி
மகவுநான்; நீதாய் அளக்கொ ணாதோ? மகிமை வளர்திருக்
கடவூ ரில்வாழ்
வாமி! சுப நேமி! புகழ் நாமி! சிவ சாமிமகிழ் வாமி!அபி ராமி!
உமையே!`,
        meaningTa: `இங்கு “பதினாறு பேறுகள்” என்பது 16 குழந்தைகள் என்று அல்ல; நோயின்மை, கல்வி, தனம், தானியம், அழகு, புகழ், பெருமை, இளமை, அறிவு, சந்தானம், வலி, துணிவு, வாழ்நாள், வெற்றி, நல்ல ஊழ், நுகர்ச்சி என பதினாறு வகை வாழ்வியல் நலன்களை குறிக்கிறது.`,
      },
    ],
  },

  {
    id: 'vishnu-108-names',
    slug: 'vishnu-108-names-tamil',
    type: 'potri',
    titleTa: '108 விஷ்ணு நாமங்கள் - ஸ்ரீ விஷ்ணு அஷ்டோத்தர சத நாமாவளி',
    titleEn: 'Vishnu Ashtottara Shatanamavali',
    deity: 'vishnu',
    shortIntroTa: 'ஸ்ரீ மகாவிஷ்ணுவின் திருநாமங்களை நாமஸ்மரணமாகச் சொல்லும் அஷ்டோத்தர சத நாமாவளி, காலை வழிபாடு மற்றும் பூஜை நேரங்களில் பயன்படுத்தப்படும் பாரம்பரிய வடிவமாகும். தெய்வீக ஓசை வீடியோ பெண்கள் குழு பாராயண பாணியில் 108 நாமங்களை வழங்குகிறது. அங்கீகரிக்கப்பட்ட production master கிடைக்கும் வரை இந்தப் பக்கத்தில் exact 108 பட்டியல் வெளியிடப்படவில்லை — வீடியோவைக் கேட்டு பின்தொடரவும்.',
    occasionTa: 'காலை/மாலை பெருமாள் வழிபாடு • புரட்டாசி • சனிக்கிழமை • தினசரி நாமஸ்மரணம்/பக்தி நேரம்',
    youtubeVideoId: 'FfwpW3DRY10',
    keywords: ['108 விஷ்ணு நாமங்கள்', 'vishnu 108 names', 'ashtottara', 'பெருமாள்'],
    seoTitle: '108 விஷ்ணு நாமங்கள் தமிழ் | Vishnu Ashtottara Shatanamavali',
    seoDescription: 'காலை வழிபாட்டிற்கு 108 விஷ்ணு திருநாமங்கள் - தெய்வீக ஓசை பெண்கள் குழு பாராயணம், பயன்பாட்டு வழிகாட்டி மற்றும் தொடர்புடைய பெருமாள் பாடல்கள்.',
    lyricsPending: true,
    relatedIds: ['sri-venkatesa-stotram', 'govinda-namavali', 'kanneerodu-vandhene'],
    verses: [],
  },
  {
    id: 'vinayagar-potri-108',
    slug: '108-vinayagar-potri-tamil',
    type: 'potri',
    titleTa: '108 விநாயகர் போற்றி - தினசரி & சதுர்த்தி வழிபாடு',
    titleEn: '108 Vinayagar Potri',
    deity: 'vinayagar',
    shortIntroTa: 'விநாயகரின் பல்வேறு திருநாமங்களையும் குணங்களையும் போற்றும் 108 போற்றிகள், விநாயகர் சதுர்த்தி மற்றும் தினசரி பூஜைகளில் பக்தியுடன் சொல்ல ஏற்ற ஒரு தொகுப்பாக தெய்வீக ஓசை வீடியோவில் வழங்கப்பட்டுள்ளது. அங்கீகரிக்கப்பட்ட போற்றி பட்டியல் கிடைக்கும் வரை exact list இங்கே வெளியிடப்படவில்லை — முழு 108 போற்றியையும் YouTube-ல் கேளுங்கள்.',
    occasionTa: 'காலை பூஜை • விநாயகர் வழிபாடு • சதுர்த்தி • புதிய முயற்சிகளுக்கு முன் மனதை ஒருமுகப்படுத்தும் நேரம்',
    youtubeVideoId: 'Kj5PAclMSJU',
    keywords: ['108 விநாயகர் போற்றி', 'vinayagar potri 108', 'விநாயகர்', 'potri'],
    seoTitle: '108 விநாயகர் போற்றி தமிழ் | Vinayagar Potri 108',
    seoDescription: 'விநாயகரின் 108 போற்றிகள் - சதுர்த்தி, காலை பூஜை மற்றும் தினசரி வழிபாட்டிற்கு தெய்வீக ஓசை வீடியோ, விளக்கம் மற்றும் தொடர்புடைய விநாயகர் பதிவுகள்.',
    lyricsPending: true,
    relatedIds: ['ganesha-pancharatnam', 'runa-vimochana-ganapati', 'vinayagar-mantras'],
    verses: [],
  },
  {
    id: 'govinda-namavali',
    slug: 'govinda-namavali-tamil',
    type: 'mantra',
    titleTa: 'கோவிந்தா நாமாவளி - புரட்டாசி பெருமாள் நாம சங்கீர்த்தனம்',
    titleEn: 'Govinda Namavali',
    deity: 'vishnu',
    shortIntroTa: '“கோவிந்தா ஹரி கோவிந்தா” என்ற நாம சங்கீர்த்தனத்துடன் ஸ்ரீநிவாசா, வேங்கடேசா, பக்தவத்ஸலா, புண்டரீகாக்ஷா, மதுசூதனா, நரசிம்ஹா, பத்மநாபா, திருமலவாசா போன்ற திருநாமங்களை இணைக்கும் தெய்வீக ஓசை நாமாவளி. இது 108 விஷ்ணு அஷ்டோத்தரத்துடன் ஒரே பக்கம் அல்ல; புரட்டாசி Govinda nama-sankeertanam என்ற தனித்த நோக்கில் அமைக்கப்பட்டுள்ளது. முழு வரிசை production master கிடைக்கும் வரை வீடியோவை முதன்மை மூலமாகக் கேளுங்கள்.',
    occasionTa: 'காலை/மாலை பெருமாள் வழிபாடு • புரட்டாசி • சனிக்கிழமை • தினசரி நாமஸ்மரணம்/பக்தி நேரம்',
    youtubeVideoId: '5wp-6IjdddA',
    keywords: ['govinda namavali', 'கோவிந்தா', 'புரட்டாசி', 'venkateswara', 'perumal'],
    seoTitle: 'Govinda Namavali Tamil | கோவிந்தா ஹரி கோவிந்தா | புரட்டாசி',
    seoDescription: 'கோவிந்தா ஹரி கோவிந்தா நாம சங்கீர்த்தனம் - ஸ்ரீனிவாசா, வேங்கடேசா உள்ளிட்ட பெருமாள் திருநாமங்களுடன் தெய்வீக ஓசை வீடியோ.',
    lyricsPending: true,
    relatedIds: ['sri-venkatesa-stotram', 'vishnu-108-names', 'kanneerodu-vandhene'],
    verses: [],
  },
  {
    id: 'kanneerodu-vandhene',
    slug: 'kanneerodu-vandhene-govinda-song',
    type: 'original-song',
    titleTa: 'கண்ணீரோடு வந்தேனே... கோவிந்தா - தெய்வீக ஓசை அசல் பெருமாள் பாடல்',
    titleEn: 'Kanneerodu Vandhene… Govinda',
    deity: 'vishnu',
    isOriginalDO: true,
    featured: true,
    shortIntroTa: '“கண்ணீரோடு வந்தேனே… கோவிந்தா” என்பது ஸ்ரீ வேங்கடேசப் பெருமானிடம் கவலைகள், தோல்விகள், குடும்ப நலம் மற்றும் மனச்சுமைகளை ஒப்படைக்கும் சரணாகதி உணர்வை மையமாகக் கொண்ட தெய்வீக ஓசை அசல் தமிழ் பக்திப் பாடல். “கேட்டதெல்லாம் வேண்டவில்லை… தாங்கும் மனம் தந்தருள்வாய்…” என்ற வரி, எல்லா சூழ்நிலைகளையும் மாற்றிக் கேட்பதற்குப் பதிலாக அவற்றை எதிர்கொள்ளும் மனவலிமையை வேண்டுகிறது.',
    themeTa: 'மனக்கவலைகளை பெருமானிடம் ஒப்படைக்கும் சரணாகதி. முழு வரிகள் அங்கீகரிக்கப்பட்ட production master கிடைக்கும்போது சேர்க்கப்படும்.',
    occasionTa: 'காலை/மாலை பெருமாள் வழிபாடு • புரட்டாசி • சனிக்கிழமை • தினசரி நாமஸ்மரணம்/பக்தி நேரம்',
    youtubeVideoId: 'Fry5RV62pGY',
    keywords: ['கண்ணீரோடு வந்தேனே', 'kanneerodu vandhene', 'govinda', 'அசல் பாடல்', 'perumal'],
    seoTitle: 'கண்ணீரோடு வந்தேனே கோவிந்தா | மனம் உருக்கும் பெருமாள் பாடல்',
    seoDescription: 'ஸ்ரீ வேங்கடேசப் பெருமானிடம் மனக்கவலைகளை ஒப்படைக்கும் தெய்வீக ஓசை அசல் தமிழ் பாடல் - கண்ணீரோடு வந்தேனே... கோவிந்தா.',
    lyricsPending: true,
    relatedIds: ['govinda-namavali', 'sri-venkatesa-stotram', 'vishnu-108-names'],
    verses: [],
  },

]
